import { render, staticRenderFns } from "./addEditActivity.vue?vue&type=template&id=823f9920&scoped=true"
import script from "./addEditActivity.vue?vue&type=script&lang=js"
export * from "./addEditActivity.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addEditActivity.vue?vue&type=style&index=1&id=823f9920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823f9920",
  null
  
)

export default component.exports